module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (88).f40a4a5f.jpg";